import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const RadioButton = ({ size, color, checked }) => {
  const getSize = inputSize => {
    let size = styles.normalSize;
    if (inputSize) {
      switch (inputSize) {
        case "small":
          size = styles.smallSize;
          break;
        case "large":
          size = styles.largeSize;
          break;
      }
    }
    return size;
  };

  // set radio size by component input
  const radioSize = getSize(size);
  // set radio color by component input

  const outerDotStyle = {
    borderColor: color
  };
  const innerDotStyle = {
    backgroundColor: color
  };

  return (
    <div
      className={cx(styles.radioButton, radioSize)}
      style={color && outerDotStyle}
    >
      <div
        className={cx(styles.innerDot, { [styles.checked]: checked })}
        style={color && innerDotStyle}
      />
    </div>
  );
};

RadioButton.defaultProps = {
  size: "large",
  color: "000",
  checked: false
};

RadioButton.propTypes = {
  size: PropTypes.oneOf(["small", "normal", "large"]),
  color: PropTypes.string,
  checked: PropTypes.bool
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/common/RadioButton/RadioButton.js